import React, { useEffect, useState, useRef } from 'react'
import './styles.css'
import Stepper from './Stepper'
import FormControl from './FormControl'
import MediaForm from './FormSteps/MediaForm'
import DetailsForm from './FormSteps/DetailsForm'
import PricingForm from './FormSteps/PricingForm'
import DateForm from './FormSteps/DateForm'
import LaunchForm from './FormSteps/LaunchForm'
import { useMediaQuery } from 'react-responsive'
import { useDispatch, useSelector } from 'react-redux'
import { clearStore, setCompanyName, setEventSlug, setIsEdit, updateFormData, updateFormDataFiles, updateFormStep } from './redux/rootSlice'
import { GoFileMedia } from "react-icons/go";
import { IoCalendarOutline } from "react-icons/io5";
import { FaRegCompass, FaWhatsapp } from "react-icons/fa";
import { FiHeart } from "react-icons/fi";
import { FaRegCreditCard } from "react-icons/fa6";
import { useForm } from "react-hook-form"
import moment from 'moment'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import toast, { Toaster } from 'react-hot-toast';
import axios from 'axios'
import { LuChevronLeft, LuChevronsLeft, LuInfo } from 'react-icons/lu'
import Button from './UI/Button'
import BackButton from './UI/BackButton'
import WhatsAppForm from "./FormSteps/WhatsAppForm";
import { persistor } from './redux/store'

const SaveConfirmModal = ({ closeModal, handleSave, isLoading, companyname, dispatch }) => {
    return (
        <div
            className="relative z-[9999]"
            aria-labelledby="modal-title"
            role="dialog"
            aria-modal="true"
        >
            <div
                className="fixed inset-0 bg-black bg-opacity-50 transition-opacity"
                aria-hidden="true"
            ></div>

            <div className="fixed inset-0 z-[9999] w-screen h-[90vh] overflow-hidden">
                <div className="flex min-h-full items-center justify-center p-4 text-center sm:p-0">
                    <div className="relative transform rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-md md:p-3">
                        <div className="w-[65vw] md:w-auto rounded-lg md:max-w-md bg-white px-4 md:px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
                            <h1 className='flex text-2xl mb-2 font-semibold items-center gap-2'>
                                {/* <LuInfo size={16} /> */}
                                Leave Without Saving?</h1>
                            <span>You may have unsaved changes.
                                If you leave now, those could be lost.
                                Would you like to save your changes before going to the dashboard?</span>
                            <div className="flex justify-between py-3 mt-4">
                                {/* <button type='button' onClick={()=>{setCoverImagePreview(null); closeModal()}} className=' bg-white font-semibold  pl-5 pr-10 py-2 text-black rounded-lg'>Cancel</button> */}
                                <BackButton
                                    text={"Discard Changes"}
                                    handleClick={async () => {
                                        closeModal();
                                        dispatch(clearStore());
                                        await persistor.purge();
                                        if (companyname == 'trove-experiences' || companyname == 'mumbai-surf-club') {
                                            window.location.href = "https://app.logout.world/dashboard/" + companyname;
                                        }
                                        else {
                                            window.location.href = "https://logout.world/dashboard/" + companyname;
                                        }
                                    }}
                                ></BackButton>
                                <Button className="w-28" text={isLoading ? <div className='dots'></div> : "Save Changes"} handleClick={handleSave} />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

const EventForm = () => {
    const steps = ['Basics', 'Details', 'WhatsApp', 'Pricing', "Dates", 'Launch']
    const steps_images = [<GoFileMedia className='w-[20px] h-[20px] md:w-[30px] md:h-[30px]' />, <FiHeart className='w-[20px] h-[20px] md:w-[30px] md:h-[30px]' />, <FaWhatsapp className='w-[20px] h-[20px] md:w-[30px] md:h-[30px]' />, <FaRegCreditCard className='w-[20px] h-[20px] md:w-[30px] md:h-[30px]' />, <IoCalendarOutline className='w-[20px] h-[20px] md:w-[30px] md:h-[30px]' />, <FaRegCompass className='w-[20px] h-[20px] md:w-[30px] md:h-[30px]' />]
    const step = useSelector(state => state.activeFormStep)
    const [activeStep, setActiveStep] = useState(step || 0)
    const isDesktop = useMediaQuery({ query: '(min-width: 1022px)' })
    const [isLoading, setIsLoading] = useState(false)
    const [salesTeam, setSalesTeam] = useState([])
    const [cityOptions, setCityOptions] = useState([])
    const [instructors, setInstructors] = useState([])
    const [companyDetails, setCompanyDetails] = useState(null)
    const location = useLocation()
    const exitRef = useRef(null)
    const [loading, setLoading] = useState(false)
    const [cities, setCities] = useState([])
    const [isSaveConfirmOpen, setIsSaveConfirmOpen] = useState(false)




    const [allAssets, setAllAssets] = useState([])



    const dispatch = useDispatch()
    var fd = new FormData();
    const { companyname, slug } = useParams();

    const navigate = useNavigate()

    const fetchCompanyDetails = async () => {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/tours/get-company-details/${companyname}`);
        const data = res.data;
        setCompanyDetails(data)
        console.log("company", data)
    }

    useEffect(() => {
        dispatch(setCompanyName(companyname));

        // Reset state before fetching new data
        // setFormData({});
        // setFormDataFiles({
        //     coverImage: null,
        //     eventImages: [],
        //     coverVideo: null,
        //     deletedPhotos: []
        // });
        dispatch(updateFormData({ formData: {} }));
        dispatch(updateFormDataFiles({ formDataFiles: {} }));

        if (slug) {
            dispatch(setEventSlug(slug));
            dispatch(setIsEdit(true));
            init(slug)
        } else {
            dispatch(setIsEdit(false));
        }
    }, [slug]);

    const init = async (slug) => {
        setLoading(true)
        console.log("called", slug)
        await getEvent(slug)
        setLoading(false)
    }

    useEffect(() => {
        (async () => {
            if (location.pathname.includes('create-event') && !formData.slug) {
                console.log("here")
                dispatch(clearStore())
                await persistor.purge();
                dispatch(setCompanyName(companyname))
                // dispatch(updateFormData({ formData: {} }));
                // dispatch(updateFormDataFiles({ formDataFiles: {} }));
                setFormData({
                    'About_Tour': '',
                    'who_for': '',
                    'name': '',
                    'event_type': "true",
                    'hosts': [],
                    'free': false,
                    'price': null,
                    'price_striked': null,
                    'gst_percentage': null,
                    'price_includes_gst': false,

                    'inclusions': '',
                    'exclusions': '',
                    'customer_pay': false,
                    'sales_representative': [],
                    'number_of_days': null,
                    'number_of_nights': null,
                    'number_of_hours': null,
                    'repeats': false,
                    'repeatType': null,
                    'variablePrices': [{
                        "temp": "temp",
                        "is_eligible_for_coupon_discount": "true"
                    }],
                    'addonPrices': [
                        {
                            "temp": "temp"
                        }
                    ],
                    "pickuppoints": [{
                        "temp": "temp"
                    }],
                    'droppoints': [{
                        "temp": "temp"
                    }],
                    'dates': [],
                    'eventId': null,
                    'tilldate': null
                })
            }
        })();

    }, [location])


    // useEffect(() => {

    //     dispatch(setCompanyName(companyname))
    //     if (slug) {
    //         console.log("found", slug)
    //         dispatch(setEventSlug(slug))
    //         dispatch(setIsEdit(true))
    //         getEvent(slug)
    //     }
    // }, [slug])

    // useEffect(() => {
    //     if (storedFormData?.slug) {
    //         getEvent(storedFormData?.slug)
    //     }
    //     // if(location.pathname.includes('edit-event')){
    //     // }
    // }, [location])

    useEffect(() => {
        if (companyname) {
            fetchCompanyDetails()
            fetchCities()
        }
    }, [companyname])


    const fetchCities = async () => {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}/tours/get-cities`);
        const cities = res.data;
        const cityOptions = [];
        cities.forEach((city) => {
            cityOptions.push({ value: city.id, label: city.name });
        });
        setCities(cities);
        setCityOptions(cityOptions);
    }

    // useEffect(() => {

    //   },[])



    useEffect(() => {
        // Scroll to top whenever the step changes
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [activeStep]);




    const isEdit = useSelector(state => state.isEdit)

    const eventSlug = useSelector(state => state.eventSlug)
    // const companyname = useSelector(state => state.companyname)

    const { register, handleSubmit, watch, formState: { errors } } = useForm();
    const [isLaunched, setIsLaunched] = useState(false)
    const storedFormData = useSelector(state => state.formData)
    const [formData, setFormData] = useState(storedFormData && Object.keys(storedFormData).length > 0 ? storedFormData : {
        'About_Tour': '',
        'who_for': '',
        'name': '',
        'event_type': "true",
        'hosts': [],
        'free': false,
        'price': null,
        'price_striked': null,
        'gst_percentage': null,
        'price_includes_gst': false,

        'inclusions': '',
        'exclusions': '',
        'customer_pay': false,
        'sales_representative': [],
        'number_of_days': null,
        'number_of_nights': null,
        'number_of_hours': null,
        'repeats': false,
        'repeatType': null,
        'variablePrices': [{
            "temp": "temp",
            "is_eligible_for_coupon_discount": "true"
        }],
        'addonPrices': [
            {
                "temp": "temp"
            }
        ],
        "pickuppoints": [{
            "temp": "temp"
        }],
        'droppoints': [{
            "temp": "temp"
        }],
        'dates': [],
        'eventId': null,
        'tilldate': null
    })


    const formFiles = useSelector(state => state.formDataFiles)
    const [formDataFiles, setFormDataFiles] = useState(formFiles && Object.keys(formFiles).length ? formFiles : {
        coverImage: null,
        eventImages: [],
        coverVideo: null,
        deletedPhotos: []
    })

    const [repeatedDays, setRepeatedDays] = useState([])

    const getEvent = async (slug) => {
        const eventSlug1 = slug || eventSlug;

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/tours/api/${eventSlug1}/`);
            if (!res.ok) {
                throw new Error("Error in fetching event");
            }

            const data1 = await res.json();
            // Create a completely new object with structuredClone
            let data = structuredClone(data1);

            // Perform all your data transformations
            data.variablePrices = data.eventprice;
            data.addonPrices = data.addoneventprice;

            // Transform batches into dates
            data.batches = data.batches.map((batch) => ({
                ...batch,
                starttime: moment(batch.starttime).format('HH:mm'),
                endtime: moment(batch.endtime).format('HH:mm')
            }));
            data.dates = data.batches;

            // Transform pricing
            data.addonPrices = data.addonPrices.map((addon) => ({
                ...addon,
                price: Math.round(addon.price),
                image: {
                    file: null,
                    preview: addon.image
                }
            }));

            data.variablePrices = data.variablePrices.map((price) => ({
                ...price,
                price: Math.round(price.price)
            }));

            // Transform event images
            const eventImages = data?.gallery?.map((image) => ({
                file: null,
                preview: image.url,
                id: image.id
            })) || [];

            data.eventImages = eventImages;
            data.price = data.price === null ? data.price : Math.round(data.price);
            data.price_striked = data.price_striked === null ? data.price_striked : Math.round(data.price_striked);
            data.gst_percentage = data.gst_percentage === null ? data.gst_percentage : Math.round(data.gst_percentage);
            data.salesRep = data.sales_representative;
            data.event_type = data.offline_event;


            // Update the state with the NEW object
            setFormData(data)

            // Update Redux store
            dispatch(updateFormData({ activeStep: activeStep, formData: data }));

            // Handle file data
            const coverImage = {
                file: null,
                preview: data.cover_pic
            };

            const coverVideo = {
                file: null,
                preview: data.cover_video
            };
            let bookingConfirmation;
            let headsUp;
            let feedbackDoc;
            if (data.booking_confirmation_image) {
                bookingConfirmation = {
                    file: null,
                    preview: data.booking_confirmation_image,
                }
            }

            if (data.heads_up_image) {
                headsUp = {
                    file: null,
                    preview: data.heads_up_image,
                }
            }

            if (data.feedbackDoc) {
                feedbackDoc = {
                    file: null,
                    preview: data.feedbackDoc,
                }
            }

            const newFormDataFiles = {
                coverImage,
                eventImages: data.eventImages,
                coverVideo,
                booking_confirmation_image: bookingConfirmation,
                heads_up_image: headsUp,
                feedbackDoc: feedbackDoc,
                deletedPhotos: []
            };

            // Update files state with NEW object
            setFormDataFiles(newFormDataFiles);

            // Update Redux store for files
            dispatch(updateFormDataFiles({
                activeStep: activeStep,
                formDataFiles: newFormDataFiles
            }));

            // Process assets if needed
            let storedAssets = [];
            data?.eventprice?.forEach((price) => {
                if (price?.package_data) {
                    storedAssets.push({
                        asset_ids: price.package_data.asset_ids,
                        package: price.package_data.package,
                        price_id: price.id
                    });
                }
            });

            setAllAssets(storedAssets);

        } catch (error) {
            console.error("Error fetching event data:", error);
            throw error;
        }
    };

    const appendIfDefined = (fd, key, value) => {
        if (value != null) {
            fd.append(key, value);
        }
    };

    const setLocationFields = (fd, formData) => {
        if (formData.event_location != null) {
            fd.set("event_location", formData.event_location);
        }
        if (formData.google_location_display_name != null) {
            fd.set("google_new_location", "true");
            fd.set("google_location_display_name", formData.google_location_display_name);
        }
        appendIfDefined(fd, "google_location_place_id", formData.google_location_place_id);
        if (formData.latlng) {
            fd.set("google_location_latitude", formData.latlng.lat);
            fd.set("google_location_longitude", formData.latlng.lng);
        }
    };

    const appendFormDataFields = (fd, data) => {
        Object.entries(data).forEach(([key, value]) => {
            if (!["short_location", "event_google_location", "google_location_place_id", "latlng", "google_new_location"].includes(key)) {
                appendIfDefined(fd, key, value);
            }
        });
    };

    const appendFileData = (fd, formDataFiles, formFiles, eventSlug, formData) => {
        const setFile = (key, source) => {
            console.log(key, source)
            if (key == 'feedback_doc') fd.set(key, source);
            else if (source?.file) fd.set(key, source.file);
            else if (source?.preview) fd.set(key, source.preview);
        };

        const coverImageSource = formDataFiles?.coverImage || formFiles?.coverImage;
        const coverVideoSource = formDataFiles?.coverVideo || formFiles?.coverVideo;
        const bookingImageSource = formDataFiles?.booking_confirmation_image || formFiles?.booking_confirmation_image;
        const headsUpSource = formDataFiles?.heads_up_image || formFiles?.heads_up_image;
        const feedbackDocSource = formDataFiles?.feedback_doc || formFiles?.feedback_doc;

        if (eventSlug || formData.id || formDataFiles?.coverImage?.file) {
            setFile("cover_pic", coverImageSource);
        }

        if (eventSlug || formData.id || formDataFiles?.coverVideo?.file) {
            setFile("cover_video", coverVideoSource);
        }

        if (formData.bookingConfirmationImage != "null" && (eventSlug || formData.id || formDataFiles?.booking_confirmation_image?.file)) {
            setFile("booking_confirmation_image", bookingImageSource);
        }

        if (formData.headsUpImage != "null" && (eventSlug || formData.id || formDataFiles?.heads_up_image?.file)) {
            setFile("heads_up_image", headsUpSource);
        }

        if (formData.feedbackDoc != "null" && (eventSlug || formData.id || formDataFiles?.feedback_doc)) {
            setFile("feedback_doc", feedbackDocSource);
        }

        const eventImages = formDataFiles?.eventImages || formFiles?.eventImages;
        eventImages?.forEach(image => {
            fd.append("eventImages", image.file || image.preview);
        });
    };

    const appendPriceData = (fd, prices, prefix) => {
        Object.entries(prices).forEach(([key, priceObj]) => {
            Object.entries(priceObj).forEach(([subKey, value]) => {
                if (subKey !== "id" || !value?.toString().startsWith("id")) {
                    const fullKey = `${key}_${prefix}_${subKey}`;
                    const val = subKey === "image" && value?.file ? value.file : value;
                    appendIfDefined(fd, fullKey, val);
                }
            });
        });
    };

    const buildCommaSeparatedCities = (arr) => {
        if (!arr || arr.length === 0) return '';

        const slugs = arr.map(name => {
            const match = cities.find(city => city.name === name);
            return match?.slug || name; // fallback to name if slug not found
        });

        return slugs.join(',');
    };

    const buildCommaSeparated = (arr) => arr?.length > 0 ? arr.join(",") : "";

    const processForm = async () => {
        console.log("Processing form", formData);
        const fd = new FormData();

        setLocationFields(fd, formData);
        appendFormDataFields(fd, formData);
        appendFileData(fd, formDataFiles, formFiles, eventSlug, formData);

        appendPriceData(fd, formData.variablePrices, "price");
        appendPriceData(fd, formData.addonPrices, "addon");

        fd.append("hosts", buildCommaSeparated(formData.hosts));
        fd.append("sales_representative", buildCommaSeparated(formData.salesRep));
        fd.set("city", buildCommaSeparatedCities(formData.cities));
        fd.append("events_category", buildCommaSeparated(formData.events_category));

        fd.append("numberofprice", formData?.variablePrices?.length ?? 0);
        fd.append("numberofaddonprice", formData?.addonPrices?.length ?? 0);
        fd.append("numberofeventpickuppoint", formData?.eventpickuppoint?.length ?? 0);
        fd.append("numberofeventdroppoint", formData?.eventdroppoint?.length ?? 0);
        fd.append("numberofbatch", formData?.dates?.length ?? 0);
        fd.append("numberofdays", 0);
        fd.append("companyname", companyname);

        console.log("FormData content", Object.fromEntries(fd.entries()));

        if (!eventSlug && !formData.id && activeStep == 0) {
            try {
                const res = await fetch(`${process.env.REACT_APP_API_URL}/tours/save-event-react-api/`, {
                    method: "POST",
                    body: fd,
                })
                if (!res.ok) {
                    throw new Error("Error in saving event")
                }
                const data = await res.json()
                console.log("data", data)
                const eventImages = data.uploaded_images.map((image) => {
                    return {
                        file: null,
                        id: image.id,
                        preview: image.url,
                    };
                });
                console.log("evimgs", eventImages)
                const coverImage = {
                    file: null,
                    preview: data.eventImage,
                };
                const coverVideo = {
                    file: null,
                    preview: data.cover_video ? data.cover_video : null,
                }
                setFormDataFiles((prev) => { return { ...prev, coverImage: coverImage, eventImages: eventImages, coverVideo: coverVideo } });
                setFormData((prev) => { return { ...prev, id: data.eventId, eventSlug: data.slug } });
                dispatch(updateFormDataFiles({ formDataFiles: { coverImage: coverImage, eventImages: eventImages, coverVideo: coverVideo } }));
                dispatch(setEventSlug(data.slug));
                // getEvent()
                try {
                    await getEvent(data.slug);

                } catch (error) {
                    console.error("Error fetching event data:", error);
                    return { error: error };

                }

                return 0;

            }
            catch (err) {
                return { error: err };
            }
        }

        else {

            if (formDataFiles?.deletedPhotos?.length > 0) {
                console.log("deleting photos", formDataFiles.deletedPhotos)
                const fdimage = new FormData();
                formDataFiles.deletedPhotos.map((photo, index) => {
                    fdimage.append("urls", photo)
                })
                try {
                    const deleteRes = await fetch(`${process.env.REACT_APP_API_URL}/tours/delete-event-photo/`, {
                        method: "POST",
                        body: fdimage
                    })
                    // if (!deleteRes.ok) {
                    //     throw new Error("Error in deleting photos")
                    // }
                    const deleteData = await deleteRes.json()
                    console.log("delted", formDataFiles)
                    const temp = structuredClone(formDataFiles)
                    temp.deletedPhotos = []
                    dispatch(updateFormDataFiles({ formDataFiles: temp }))
                    setFormDataFiles({ ...formDataFiles, deletedPhotos: [] })
                }
                catch (err) {
                    console.log("error", err)
                    return { error: err };
                }

            }
            if (activeStep == 0) {
                console.log("new imgs", formDataFiles.eventImages)
                formDataFiles?.eventImages?.map((image, index) => {
                    if (image.file) {
                        fd.append("newEventImages", image.file)
                    }
                })
            }
            if (formData.host_event_pdf_file == null) {
                fd.delete("host_event_pdf_file")
                fd.append("host_event_pdf_file", '')
            }
            if (activeStep == 4) {
                fd.set("publish", true)
            }
            try {
                if (!formData.repeats) {
                    for (var key in formData.dates) {
                        for (var key2 in formData.dates[key]) {
                            if (key2 == "id" && formData.dates[key][key2] == undefined) {
                                // fd.append(key + "_batch_" + key2, formData.dates[key][key2]);
                                continue;
                            }
                            fd.append(key + "_batch_" + key2, formData.dates[key][key2]);

                        }
                    }
                    setFormData({ ...formData, dates: [] })
                }
                if (allAssets?.length > 0) {
                    allAssets.map((asset, index) => {
                        let updated = structuredClone(asset)
                        delete updated.price_id
                        fd.append(`${index}_asset_data`, JSON.stringify(updated))
                        fd.append(`${index}_is_package`, "true")
                    })
                }
                const updateRes = await fetch(`${process.env.REACT_APP_API_URL}/tours/update-event-react-api/`, {
                    method: "POST",
                    body: fd,
                })
                if (!updateRes.ok) {
                    throw new Error("Error in updating event")
                }
                const updateData = await updateRes.json()
                const eventImages = updateData?.uploaded_images?.map((image) => {
                    return {
                        file: null,
                        preview: image.url,
                        id: image.id
                    };
                })
                const bookingConfirmation = {
                    file: null,
                    preview: updateData.booking_confirmation_image,
                };
                const headsUp = {
                    file: null,
                    preview: updateData.heads_up_image,
                }
                const feedbackDoc = {
                    file: null,
                    preview: updateData.feedbackDoc,
                }
                const evimgs = formDataFiles?.eventImages?.filter((image) => image.file == null)
                dispatch(updateFormDataFiles({ formDataFiles: { ...formDataFiles, eventImages: evimgs?.concat(eventImages), booking_confirmation_image: bookingConfirmation, heads_up_image: headsUp, feedbackDoc: feedbackDoc, feedback_doc: feedbackDoc } }));

                if (formData.repeats) {
                    var data;
                    console.log("repeats", formData)
                    if (formData.repeatType == "everyday") {
                        console.log(formData.repeatedDate)
                        const num = Math.round(
                            (new Date(formData.repeatedDate.enddate) - new Date(formData.repeatedDate.startdate)) / (1000 * 60 * 60 * 24)
                        );
                        console.log("here", num)
                        data = {
                            startdate: formData.repeatedDate.startdate,
                            enddate: formData.repeatedDate.enddate,
                            starttime: formData.repeatedDate.starttime,
                            endtime: formData.repeatedDate.endtime,
                            repeats: formData.repeats,
                            repeatType: formData.rerepeatedDate,
                            changeEndTime: true,
                            tillDate: formData.tilldate,
                            numberOfDays: num,
                        };
                        console.log(data);
                    } else {
                        data = {
                            startdate: formData.repeatedDate.startdate,
                            enddate: formData.repeatedDate.enddate,
                            starttime: formData.repeatedDate.starttime,
                            endtime: formData.repeatedDate.endtime,
                            repeats: formData.repeats,
                            repeatType: formData.repeatType,
                            changeEndTime: true,
                            tillDate: formData.tilldate,
                            numberOfDays: null,
                            repeatedDays: repeatedDays,

                        };
                        console.log(data);
                    }
                    try {
                        const batchRes = await fetch(`${process.env.REACT_APP_API_URL}/tours/${eventSlug}/add-bulk-batches-api/`, {
                            method: "POST",
                            body: JSON.stringify({ batchData: data }),
                        })
                        if (!batchRes.ok) {
                            throw new Error("Error in adding batches")
                        }
                        const batchData = await batchRes.json()

                    }
                    catch (err) {
                        console.log("error", err)
                        return { error: err };
                    }
                    setFormData({ ...formData, repeats: false, repeatType: null, repeatedDate: null, tilldate: null, startdate: null, enddate: null })

                }

                return 0;
            }
            catch (err) {
                console.log("error", err)
                return { error: err };
            }

        }

        // Submission logic would go here: save vs update logic
    };



    // const processForm = async () => {
    //     console.log("processing form", formData)
    //     for (var key in formData) {
    //         if (key == 'short_location') {
    //             if(formData[key] != undefined){
    //             fd.set("event_location", formData[key])
    //             }
    //         } else if (key == "event_google_location" || key == "google_location_display_name") {
    //             if (formData['event_google_location'] != 'undefined' || formData['event_google_location'] != undefined) {
    //                 fd.set("google_new_location", "true")
    //                 fd.set("google_location_display_name", formData['event_google_location'])
    //             }
    //         }
    //         else if (key == "google_location_place_id" && formData['google_location_place_id'] != undefined) {
    //             fd.set("google_location_place_id", formData['google_location_place_id'])
    //         }
    //         else if (key == "latlng" && formData['latlng'] != undefined) {
    //             fd.set("google_location_latitude", formData['latlng'].lat)
    //             fd.set("google_location_longitude", formData['latlng'].lng)
    //         }
    //         else if(formData[key] != undefined){
    //             fd.append(key, formData[key]);
    //         }
    //     }

    //     if (eventSlug || formData.id) {
    //         if (formDataFiles?.coverImage?.file) {
    //             fd.set("cover_pic", formDataFiles.coverImage.file);
    //         } else if (formFiles?.coverImage?.preview) {
    //             fd.set("cover_pic", formFiles.coverImage.preview);
    //         }
    //     } else {
    //         if (formDataFiles?.coverImage?.file) {
    //             fd.set("cover_pic", formDataFiles.coverImage.file);
    //         }
    //     }

    //     if (formDataFiles.eventImages) {
    //         formDataFiles?.eventImages?.map((image, index) => {
    //             fd.append("eventImages", image.file);
    //         });
    //     } else {
    //         formFiles?.eventImages?.map((image, index) => {
    //             fd.append("eventImages", image.preview);
    //         });
    //     }

    //     if (eventSlug || formData.id) {
    //         if (formDataFiles?.coverVideo?.file) {
    //             fd.set("cover_video", formDataFiles.coverVideo.file);
    //         } else if (formFiles?.coverVideo?.preview) {
    //             fd.set("cover_video", formFiles.coverVideo.preview);
    //         }
    //     } else {
    //         if (formDataFiles?.coverVideo?.file) {
    //             fd.set("cover_video", formDataFiles.coverVideo.file);
    //         }
    //     }

    //     // fd.append("hosts", formData.hosts);
    //     for (var key in formData.variablePrices) {
    //         for (var key2 in formData.variablePrices[key]) {
    //             // Check if the value of 'id' starts with 'id' and the value exists
    //             if (!(key2 === "id" && formData.variablePrices[key][key2] && formData.variablePrices[key][key2].toString().startsWith('id'))) {
    //                 fd.append(key + "_price_" + key2, formData.variablePrices[key][key2]);
    //             }
    //         }
    //     }

    //     for (var key in formData.addonPrices) {
    //         for (var key2 in formData.addonPrices[key]) {
    //             console.log(key2, " : ", formData.addonPrices[key][key2]);
    //             if (!(key2 === "id" && formData.addonPrices[key][key2] && formData.addonPrices[key][key2].toString().startsWith('id'))) {
    //             if (key2 == "image") {
    //                 fd.append(key + "_addon_" + key2, formData.addonPrices[key][key2]?.file);
    //             } else {
    //                 fd.append(key + "_addon_" + key2, formData.addonPrices[key][key2]);
    //             }
    //         }}
    //     }

    //     const hosts = formData?.hosts?.length > 0 && formData?.hosts?.map((option) => option).join(",");
    //     const sales = formData?.salesRep?.length > 0 && formData?.salesRep?.map((option) => option).join(",");
    //     const categories = formData?.events_category?.length > 0 && formData?.events_category?.map((option) => option).join(",");
    //     const cities = formData?.cities?.length > 0 && formData?.cities?.map((option) => option).join(",");
    //     fd.append("hosts", hosts);
    //     fd.append("sales_representative", sales);
    //     fd.append("city", cities);
    //     fd.append("events_category", categories);
    //     fd.append("numberofprice", formData?.variablePrices?.length);
    //     fd.append("numberofaddonprice", formData?.addonPrices?.length);
    //     fd.append("numberofeventpickuppoint", formData?.eventpickuppoint ? formData?.eventpickuppoint?.length : 0);
    //     fd.append("numberofeventdroppoint", formData?.eventdroppoint ? formData?.eventdroppoint?.length : 0);
    //     fd.append("numberofbatch", formData?.dates?.length);
    //     fd.append('numberofdays', 0)


    //     fd.append("companyname", companyname);

    //     console.log("fd", [...fd]);

    //     if (!eventSlug && !formData.id && activeStep == 0) {
    //         try {

    //             const res = await fetch(`${process.env.REACT_APP_API_URL}/tours/save-event-react-api/`, {
    //                 method: "POST",
    //                 body: fd,
    //             })
    //             if (!res.ok) {
    //                 throw new Error("Error in saving event")
    //             }
    //             const data = await res.json()
    //             console.log("data", data)
    //             const eventImages = data.uploaded_images.map((image) => {
    //                 return {
    //                     file: null,
    //                     id: image.id,
    //                     preview: image.url,
    //                 };
    //             });
    //             console.log("evimgs", eventImages)
    //             const coverImage = {
    //                 file: null,
    //                 preview: data.eventImage,
    //             };
    //             const coverVideo = {
    //                 file: null,
    //                 preview: data.cover_video ? data.cover_video : null,
    //             }
    //             setFormDataFiles({ ...formDataFiles, coverImage: coverImage, eventImages: eventImages, coverVideo: coverVideo });
    //             setFormData({ ...formData, id: data.eventId, eventSlug: data.slug });
    //             dispatch(updateFormDataFiles({ formDataFiles: { coverImage: coverImage, eventImages: eventImages, coverVideo: coverVideo } }));
    //             dispatch(setEventSlug(data.slug));
    //             // getEvent()
    //             try {
    //                 await getEvent(data.slug);

    //             } catch (error) {
    //                 console.error("Error fetching event data:", error);
    //                 return { error: error };

    //             }

    //             return 0;

    //         }
    //         catch (err) {
    //             return { error: err };
    //         }
    //     }

    //     else {

    //         if (formDataFiles?.deletedPhotos?.length > 0) {
    //             console.log("deleting photos", formDataFiles.deletedPhotos)
    //             const fdimage = new FormData();
    //             formDataFiles.deletedPhotos.map((photo, index) => {
    //                 fdimage.append("urls", photo)
    //             })
    //             try {
    //                 const deleteRes = await fetch(`${process.env.REACT_APP_API_URL}/tours/delete-event-photo/`, {
    //                     method: "POST",
    //                     body: fdimage
    //                 })
    //                 // if (!deleteRes.ok) {
    //                 //     throw new Error("Error in deleting photos")
    //                 // }
    //                 const deleteData = await deleteRes.json()
    //                 console.log("delted", formDataFiles)
    //                 const temp = structuredClone(formDataFiles)
    //                 temp.deletedPhotos = []
    //                 dispatch(updateFormDataFiles({ formDataFiles: temp }))
    //                 setFormDataFiles({ ...formDataFiles, deletedPhotos: [] })
    //             }
    //             catch (err) {
    //                 console.log("error", err)
    //                 return { error: err };
    //             }

    //         }
    //         if (activeStep == 0) {
    //             console.log("new imgs", formDataFiles.eventImages)
    //             formDataFiles?.eventImages?.map((image, index) => {
    //                 if (image.file) {
    //                     fd.append("newEventImages", image.file)
    //                 }
    //             })
    //         }
    //         if (formData.host_event_pdf_file == null) {
    //             fd.delete("host_event_pdf_file")
    //             fd.append("host_event_pdf_file", '')
    //         }
    //         if (activeStep == 4) {
    //             fd.set("publish", true)
    //         }
    //         try {
    //             if (!formData.repeats) {
    //                 for (var key in formData.dates) {
    //                     for (var key2 in formData.dates[key]) {
    //                         if (key2 == "id" && formData.dates[key][key2] == undefined) {
    //                             // fd.append(key + "_batch_" + key2, formData.dates[key][key2]);
    //                             continue;
    //                         }
    //                         fd.append(key + "_batch_" + key2, formData.dates[key][key2]);

    //                     }
    //                 }
    //                 setFormData({ ...formData, dates: [] })
    //             }
    //             if (allAssets?.length > 0) {
    //                 allAssets.map((asset, index) => {
    //                     let updated = structuredClone(asset)
    //                     delete updated.price_id
    //                     fd.append(`${index}_asset_data`, JSON.stringify(updated))
    //                     fd.append(`${index}_is_package`, "true")
    //                 })
    //             }
    //             const updateRes = await fetch(`${process.env.REACT_APP_API_URL}/tours/update-event-react-api/`, {
    //                 method: "POST",
    //                 body: fd,
    //             })
    //             if (!updateRes.ok) {
    //                 throw new Error("Error in updating event")
    //             }
    //             const updateData = await updateRes.json()
    //             console.log("files", formDataFiles);
    //             const eventImages = updateData?.uploaded_images?.map((image) => {
    //                 return {
    //                     file: null,
    //                     preview: image.url,
    //                     id: image.id
    //                 };
    //             })
    //             const evimgs = formDataFiles?.eventImages?.filter((image) => image.file == null)
    //             console.log("new", eventImages)
    //             dispatch(updateFormDataFiles({ formDataFiles: { ...formDataFiles, eventImages: evimgs?.concat(eventImages) } }));
    //             // await getEvent();

    //             if (formData.repeats) {
    //                 var data;
    //                 console.log("repeats", formData)
    //                 if (formData.repeatType == "everyday") {
    //                     console.log(formData.repeatedDate)
    //                     const num = Math.round(
    //                         (new Date(formData.repeatedDate.enddate) - new Date(formData.repeatedDate.startdate)) / (1000 * 60 * 60 * 24)
    //                     );
    //                     console.log("here", num)
    //                     data = {
    //                         startdate: formData.repeatedDate.startdate,
    //                         enddate: formData.repeatedDate.enddate,
    //                         starttime: formData.repeatedDate.starttime,
    //                         endtime: formData.repeatedDate.endtime,
    //                         repeats: formData.repeats,
    //                         repeatType: formData.rerepeatedDate,
    //                         changeEndTime: true,
    //                         tillDate: formData.tilldate,
    //                         numberOfDays: num,
    //                     };
    //                     console.log(data);
    //                 } else {
    //                     data = {
    //                         startdate: formData.repeatedDate.startdate,
    //                         enddate: formData.repeatedDate.enddate,
    //                         starttime: formData.repeatedDate.starttime,
    //                         endtime: formData.repeatedDate.endtime,
    //                         repeats: formData.repeats,
    //                         repeatType: formData.repeatType,
    //                         changeEndTime: true,
    //                         tillDate: formData.tilldate,
    //                         numberOfDays: null,
    //                         repeatedDays: repeatedDays,

    //                     };
    //                     console.log(data);
    //                 }
    //                 try {
    //                     const batchRes = await fetch(`${process.env.REACT_APP_API_URL}/tours/${eventSlug}/add-bulk-batches-api/`, {
    //                         method: "POST",
    //                         body: JSON.stringify({ batchData: data }),
    //                     })
    //                     if (!batchRes.ok) {
    //                         throw new Error("Error in adding batches")
    //                     }
    //                     const batchData = await batchRes.json()

    //                 }
    //                 catch (err) {
    //                     console.log("error", err)
    //                     return { error: err };
    //                 }
    //                 setFormData({ ...formData, repeats: false, repeatType: null, repeatedDate: null, tilldate: null, startdate: null, enddate: null })

    //             }

    //             return 0;
    //         }
    //         catch (err) {
    //             console.log("error", err)
    //             return { error: err };
    //         }

    //     }
    // };

    const handleSaveExit = () => {
        exitRef.current = true;
        console.log("Saving and exiting", formData);
        handleNext()
    }




    const handleNext = async (e) => {
        console.log(formData)
        setIsLoading(true)
        const res = await processForm();
        if (!res.error && isEdit && exitRef.current) {
            dispatch(clearStore());
            await persistor.purge();
            if (companyname == 'trove-experiences' || companyname == 'mumbai-surf-club') {
                window.location.href = "https://app.logout.world/dashboard/" + companyname;
            }
            else {
                window.location.href = "https://logout.world/dashboard/" + companyname;
            }
        }
        setIsLoading(false)
        if (res.error) {

            toast.error(res.error.message)
        }
        if (!res.error) {
            if (activeStep == 0 && !eventSlug) {
                toast.success('Good start!')
            }
            else {
                toast.success('Good going!')
            }
            const temp = structuredClone(formData)
            temp.addonPrices.map((addon, index) => {
                console.log("addon", addon.image)
                if (addon.image) {
                    addon.image.file = null
                }
            })
            temp.city = temp.cities
            temp.host_event_pdf_file = temp.host_event_pdf_file instanceof File ? URL.createObjectURL(temp.host_event_pdf_file) : temp.host_event_pdf_file
            dispatch(updateFormData({ activeStep: activeStep, formData: temp }))
            console.log("upadtinf", formData)
            // if (activeStep == 0 && !isEdit) {
            //     console.log(formDataFiles)
            //     const temp = structuredClone(formDataFiles)
            //     console.log("temp", temp)
            //     if (temp.coverImage) {
            //         temp.coverImage.file = null
            //     }
            //     if (temp.coverVideo) {
            //         temp.coverVideo.file = null
            //     }
            //     temp?.eventImages?.map((image, index) => {
            //         image.file = null
            //     })
            //     dispatch(updateFormDataFiles({ activeStep: activeStep, formDataFiles: temp }))

            // }
            console.log("submitted")

            if (activeStep < steps.length - 1) {
                setActiveStep(activeStep + 1)
                dispatch(updateFormStep(activeStep + 1))
            }
            else {
                setIsLaunched(true)
                // dispatch(clearStore())
                // setActiveStep(0)
                // navigate(`${process.env.REACT_APP_API_URL}/dashboard/${companyname}`)

            }
            // if(activeStep == steps.length-1){
            //     clearState()
            // }
        }
    }

    const handleBack = () => {
        if (activeStep > 0) {
            setActiveStep(activeStep - 1)
            dispatch(updateFormStep(activeStep - 1))
        }
    }

    const formStep = () => {
        switch (activeStep) {
            case 0:
                return !loading ? <MediaForm register={register} errors={errors} formDataFiles={formDataFiles} setFormDataFiles={setFormDataFiles} formData={formData} setFormData={setFormData} cityOptions={cityOptions} /> : 'loading...'
            case 1:
                return <DetailsForm register={register} errors={errors} formData={formData} setFormData={setFormData} salesTeam={salesTeam} instructors={instructors} />
            case 2:
                return <WhatsAppForm formData={formData} setFormData={setFormData} companyDetails={companyDetails} setFormDataFiles={setFormDataFiles} />
            case 3:
                return <PricingForm formData={formData} setFormData={setFormData} companyDetails={companyDetails} allAssets={allAssets} setAllAssets={setAllAssets} />
            case 4:
                return <DateForm formData={formData} setFormData={setFormData} setRepeatedDays={setRepeatedDays} />
            case 5:
                return <LaunchForm isLaunched={isLaunched} setIsLaunched={setIsLaunched} companyDetails={companyDetails} />

        }
    }

    useEffect(() => {
        console.log("all_assets", formDataFiles)
    }, [formDataFiles])

    return (
        <div className='bodydiv'>
            <Toaster />
            {!isDesktop && <div className='overflow-scroll'>
                <nav
                    className="navbar flex justify-between shadow-sm sticky top-0 w-full items-center bg-black bg-gradient-to-r z-10 from-black to-black py-4"
                >
                    <span
                        className="navbar-brand cursor-pointer"
                        onClick={() => {
                            if (companyname === 'trove-experiences' || companyname === 'mumbai-surf-club') {
                                window.location.href = "https://app.logout.world/dashboard/" + companyname;
                            } else {
                                window.location.href = "https://logout.world/dashboard/" + companyname;
                            }
                        }}
                    >
                        <p className="mb-0 flex items-center">
                            <i
                                className="far fa-compass transform rotate-8 text-[#fd305e] text-2xl pl-4 pr-2"
                                style={{ fontSize: '1.8rem' }}
                            ></i>
                            <span className="text-lg text-white">
                                <b>
                                    <span className="text-[#f7e4cb] text-[24px] font-semibold">Logout</span>
                                    <span className="text-[#f7e4cb] text-[24px] font-semibold">.Studio</span>
                                </b>
                            </span>
                        </p>
                    </span>

                    <div className="pr-4">
                        <span
                            className="text-[12.025px] cursor-pointer shadow-sm text-white bg-[#045540]  border-green-500 px-3 py-2 rounded flex items-center"
                            onClick={() => {
                                if (companyname === 'trove-experiences' || companyname === 'mumbai-surf-club') {
                                    window.location.href = "https://app.logout.world/dashboard/" + companyname;
                                } else {
                                    window.location.href = "https://logout.world/dashboard/" + companyname;
                                }
                            }}
                        >
                            <i
                                className="fas fa-fw fa-chevron-circle-left text-white mr-2"
                            ></i>
                            Goto Dashboard
                        </span>
                    </div>
                </nav>
                <div className=''>
                    <Stepper setActiveStep={setActiveStep} activeStep={activeStep} steps={steps} steps_images={steps_images} />
                </div>
                <form onSubmit={handleSubmit(handleNext)} className='mt-8 relative max-h-[80vh] overflow-scroll bg-form_background shadow-[rgba(0,0,0,0.2)_0px_-3px_5px_0px] rounded-t-2xl '>
                    <div className='' >
                        {formStep()}
                    </div>

                    <FormControl exitRef={exitRef} isLoading={isLoading} activeStep={activeStep} handleBack={handleBack} handleNext={handleNext} />

                </form>
            </div>
            }




            {

                isDesktop &&
                <div>
                    <nav
                        className="navbar flex justify-between shadow-sm sticky top-0 w-full items-center bg-black bg-gradient-to-r from-black to-black z-10 py-4"
                    >
                        <a className="navbar-brand" href={`/dashboard/${companyname}`}>
                            <p className="mb-0 flex items-center">
                                <i
                                    className="far fa-compass transform rotate-8 text-[#fd305e] text-2xl pl-4 pr-2"
                                    style={{ fontSize: '1.8rem' }}
                                ></i>
                                <span className="text-lg text-white">
                                    <b>
                                        <span className="text-[#f7e4cb] text-[24px] font-semibold">Logout</span>
                                        <span className="text-[#f7e4cb] text-[24px] font-semibold">.Studio</span>
                                    </b>
                                </span>
                            </p>
                        </a>

                        <div className="pr-4 flex items-center gap-4">
                            <span
                                onClick={() => { setIsSaveConfirmOpen(true) }}
                                className="text-[0.925rem] shadow-sm cursor-pointer  bg-[#045540]  border-green-500 px-4 py-2 rounded flex items-center gap-1"
                            // href={`/dashboard/${companyname}`}
                            >
                                {/* <i
                                    className="fas fa-fw fa-chevron-circle-left text-white mr-2"
                                ></i> */}
                                <LuChevronsLeft size={22} />
                                Goto Dashboard
                            </span>

                        </div>
                    </nav>

                    <div className="flex overflow-hidden">
                        <div className="sidebar w-[16.5%] fixed left-0 h-full overflow-hidden flex justify-center py-8 bg-form_background border-r-[1px] border-black border-opacity-30">
                            <Stepper setActiveStep={setActiveStep} activeStep={activeStep} steps={steps} steps_images={steps_images} />
                        </div>
                        <div className="main overflow-hidden flex-grow bg-form_background">
                            <form onSubmit={handleSubmit(handleNext)} className="overflow-auto ml-[16.5%]">
                                <div className="min-h-[96vh] px-20 pt-10">{formStep()}</div>
                                <FormControl
                                    isDesktop={isDesktop}
                                    activeStep={activeStep}
                                    handleBack={handleBack}
                                    handleNext={handleNext}
                                    isLoading={isLoading}
                                    exitRef={exitRef}
                                />
                            </form>
                        </div>
                    </div>
                </div>


            }
            {isSaveConfirmOpen && <SaveConfirmModal companyname={companyname} closeModal={() => { setIsSaveConfirmOpen(false) }} handleSave={handleSaveExit} isLoading={isLoading} dispatch={dispatch} />}

        </div>
    )
}

export default EventForm



